import { render, staticRenderFns } from "./clinicEditor.vue?vue&type=template&id=085b7379&scoped=true"
import script from "./clinicEditor.vue?vue&type=script&lang=js"
export * from "./clinicEditor.vue?vue&type=script&lang=js"
import style0 from "./clinicEditor.vue?vue&type=style&index=0&id=085b7379&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085b7379",
  null
  
)

export default component.exports